/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import NProgress from 'nprogress';
import Backbone from 'backbone';

import Session from '@/Session';
import Scaffold from '@/Scaffold';
import * as NavUtils from '@/util/NavUtils';
import { userHasRole } from '@/util/RoleUtils';
import ErrorView from '@/views/ErrorView';
import GetAllOrderFormTypes from '@/services/GetAllOrderFormTypes';

import CreateOrderPage from '../pages/CreateOrderPage';
import GetCommandDetails from '../../command/services/GetCommandDetails';

export default async function ShowCreateOrderPage(commandId) {
  NProgress.start();

  try {
    const user = Session.user;
    if (userHasRole('CRS') || userHasRole('Admin')) {
      user.isAuthorized = '1';
    } else if (EXTERNAL) {
      showErrorView();
      return;
    }

    NavUtils.navigate(`order/create/${commandId}`);

    const commandDetails = await GetCommandDetails(commandId);
    const commandName = commandDetails.commandName;
    if (!commandId && !userHasRole('CRS')) {
      //FIXME
      throw new Error();
    }

    let orderFormTypes = await GetAllOrderFormTypes();
    orderFormTypes = _.filter(orderFormTypes, (type) => {
      //remove original PRTNR form from order types
      return type.id !== '2';
    });
    _.each(orderFormTypes, (x) => {
      x.name = x.descriptiveFormName;
    });

    Scaffold.getRegion('content').show(
      new CreateOrderPage({
        model: new Backbone.Model({
          returnLabel: 'Return to Dashboard',
          returnLink: '#dashboard',
          commandId,
          commandName,
          orderFormTypes,
          internalUser: true
        })
      })
    );
  } catch (err) {
    Scaffold.getRegion('content').show(
      new ErrorView({
        model: new Backbone.Model({
          errorMessage: _.isString(err.message) ? err.message : 'An Error Occurred',
          errorDetails: 'Something went wrong while loading the Create Order page.'
        })
      })
    );
  } finally {
    NProgress.done();
  }
}

function showErrorView() {
  Scaffold.getRegion('content').show(
    new ErrorView({
      model: new Backbone.Model({
        errorMessage: 'Access Denied',
        errorDetails: 'Your account may not have permission to view the Internal Create Order page.'
      })
    })
  );
  NProgress.done();
}